import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { store } from '../../store/jotai/JotaiStore';
import { toastrAtom } from './ToastrState';

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const showMessage = (
  title: string,
  message: string,
  color: string,
  duration: number | null = null,
  messagePayload: Record<string, any> | null = null
): void => {
  store.set(toastrAtom, {
    title,
    message,
    color,
    duration,
    messagePayload,
  });
};

export const hideMessage = (): void => {
  store.set(toastrAtom, null);
};

export const convertUtcDateInString = (input: string): string => {
  const dateRegex = /(\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2})|(\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2})/;
  const match = input.match(dateRegex);
  if (!match) {
    return input;
  }
  const originalDate = match[0];
  const isDotFormat = /^\d{2}\.\d{2}\.\d{4}/.test(originalDate);
  const inputFormat = isDotFormat ? 'DD.MM.YYYY HH:mm' : 'YYYY-MM-DD HH:mm:ss';
  const parsed = dayjs.utc(originalDate, inputFormat);
  if (!parsed.isValid()) {
    return input;
  }
  const localDate = parsed.local().format('DD.MM.YYYY HH:mm');
  return input.replace(originalDate, localDate);
};

export default showMessage;
